import { useLoading } from "../components/LoadingContext";
import axios from "../api/axiosClient";
import { handleError, errorToast, useKeyDown } from "../services/serviceBase";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import CustomTable from "../components/ui/CustomTable";
import CustomGridHeaderCell from "../components/ui/CustomGridHeaderCell";
import {
  Button,
  Typography,
  Box,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import PageHeader from "../components/ui/PageHeader";
import BarcodeIcon from "../components/ui/BarcodeIcon";
import toast from "react-hot-toast";
import Input from "@mui/material/Input";
import { useNavigate } from "react-router-dom";

export default function CheckIn(props) {
  const { setLoading } = useLoading();
  const intl = useIntl();
  const params = useParams();
  const { idReturnFileHead } = params;
  const navigate = useNavigate();

  const [firstPageLoad, setFirstPageLoad] = useState(true);
  const [checkInData, setCheckInData] = useState([]);
  const [existingBarcodes, setExistingBarcodes] = useState([]);
  const [columns, setColumns] = useState([]);
  const [dossierKey, setDossierKey] = useState("");
  const [boxInBarcode, setBoxInBarcode] = useState("");
  const [checkInBarcode, setCheckInBarcode] = useState("");
  const [selectedBoxInBarcodes, setSelectedBoxInBarcodes] = useState([]);

  const handleBoxInBarcodeChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setBoxInBarcode(barcode);
    }
  };

  const handleCheckInBarcodeChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setCheckInBarcode(barcode);
    }
  };

  useKeyDown(() => {
    var clickedId = document.activeElement.id;
    if (clickedId == document.getElementById("boxInInput").id) {
      handleSetBoxInBarcodes();
    }
    if (clickedId == document.getElementById("boxCheckInInput").id) {
      handleSetBoxCheckInBarcodes();
    }
  }, ["Enter"]);

  const handleSetBoxInBarcodes = () => {
    if (!existingBarcodes.includes(boxInBarcode)) {
      toast.error(intl.formatMessage({ id: "CheckIn.BoxInNotFound" }));
      return;
    }

    if (
      selectedBoxInBarcodes.includes(
        document.getElementById("boxInInput").value
      )
    ) {
      var newSelected = [];
      selectedBoxInBarcodes.forEach((element) => {
        if (element != document.getElementById("boxInInput").value) {
          newSelected.push(element);
        }
      });
      setSelectedBoxInBarcodes(newSelected);
    } else {
      var newSelected = [];
      selectedBoxInBarcodes.forEach((element) => {
        newSelected.push(element);
      });
      newSelected.push(boxInBarcode);
      setSelectedBoxInBarcodes(newSelected);
    }
  };

  const handleSetBoxCheckInBarcodes = () => {
    var newData = checkInData;
    if (selectedBoxInBarcodes.length > 0) {
      newData.forEach((element) => {
        if ((element.checkInCarton == "" || element.checkInCarton == null) && selectedBoxInBarcodes.includes(element.boxInCarton)) {
          element.checkInCarton =
            document.getElementById("boxCheckInInput").value;
        }
      });
    }
    setCheckInData(newData);
    setSelectedBoxInBarcodes([]);
  };

  useEffect(() => {
    getCheckInData();
  }, []);

  useEffect(() => {
    if (checkInData.length > 0) {
      getColumns();
      setDossierKey(checkInData[0].dossierKey);
      if (firstPageLoad) {
        setSelectedBoxInBarcodes(checkInData.map((x) => x.boxInCarton));
        setFirstPageLoad(false);
      }
    }
  }, [checkInData]);

  const getCheckInData = () => {
    setLoading(true);
    axios
      .get(`/returnfiles/checkin/${idReturnFileHead}`)
      .then((response) => {
        setLoading(false);
        setCheckInData(response.data);
        setExistingBarcodes(response.data.map((x) => x.boxInCarton));
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleSaveCheckIn = () => {
    var message = intl.formatMessage({ id: "CheckIn.ConfirmCheckIn" });
    if (!window.confirm(message)) {
      return false;
    }
    saveCheckInData();
  };

  const saveCheckInData = () => {
    var data = [];
    checkInData.map((x) => {
      if(x.checkInCarton != null && x.checkInCarton != ""){
        data.push({ checkInCarton: x.checkInCarton, boxInCarton: x.boxInCarton });
      }
    });

    var countCheckIn = new Set(data.map((x) => x.checkInCarton)).size;

    const result = {};
    for (const { checkInCarton, boxInCarton } of data) {
      if (!result[checkInCarton]) result[checkInCarton] = [];
      var boxIn = result[checkInCarton].push({ boxInCarton });
    }

    let model = [];
    for (let i = 0; i < countCheckIn; i++) {
      let boxInList = Object.values(result)[i].map((x) => x.boxInCarton);
      let boxCheckIn = Object.keys(result)[i];
      model.push({ boxInList: boxInList, boxCheckIn: boxCheckIn });
    }

    let finalModel = { rowsBoxCheckInModels: model };
    setLoading(true);
    let url = `/returnfiles/checkin/${idReturnFileHead}`;
    axios
      .post(url, finalModel)
      .then((response) => {
        setLoading(false);
        toast.success("Saved!");
        navigate(`${process.env.PUBLIC_URL}/QCDetail/${idReturnFileHead}`);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handlePrintLabel = (carton) => {
    var message = intl.formatMessage({ id: "CheckIn.ConfirmPrint" });
    if (!window.confirm(message)) {
      return false;
    }
    printLabel(carton);
  };

  const printLabel = (carton) => {
    var model = {
      idReturnFileHead: idReturnFileHead,
      boxInCartonList: (carton) ? [carton] : [],
    };
    setLoading(true);
    let url = `/returnfiles/checkin/print`;
    axios
      .post(url, model)
      .then((response) => {
        setLoading(false);
        toast.success("Printing request sent..");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const onSelectionFunc = (ids) => {
    setSelectedBoxInBarcodes(ids);
  };

  const handleCheckInCartonChange = (e, boxInCarton, checkInCarton) => {
    setCheckInData(
      checkInData.map((row) =>
        row.boxInCarton === boxInCarton
          ? { ...row, checkInCarton: e.target.value, changedCarton: true }
          : row
      )
    );
  };

  const getColumns = () => {
    setColumns([
      {
        field: "boxInCarton",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "CheckIn.BoxInUDM" })}
          />
        ),
        flex: 1,
      },
      {
        field: "boxNumber",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: (params) => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "CheckIn.BoxTotBoxTot" })}
          />
        ),
        flex: 1,
        renderCell: (params) => {
          return (
            <Typography variant="normal">
              {params.row.boxNumber}/{params.row.boxTotal}
            </Typography>
          );
        },
      },
      {
        field: "quantity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "CheckIn.QtyTot" })}
          />
        ),
        flex: 1,
      },
      {
        field: "checkInCarton",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "CheckIn.CheckInUDM" })}
          />
        ),
        flex: 1,
        renderCell: (params) => {
          let inputRowId = "input-checkInCarton-" + params.row.boxInCarton;
          return (
            <Input
              id={inputRowId}
              type="text"
              sx={{ width: "100%" }}
              value={params.row.checkInCarton}
              onChange={(e) =>
                handleCheckInCartonChange(
                  e,
                  params.row.boxInCarton,
                  params.row.checkInCarton
                )
              }
            ></Input>
          );
        },
      },
      {
        field: "actions",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        flex: 1,
        minWidth: 50,
        maxWidth: 140,
        renderCell: (params) => {
          return (
            <Button
              onClick={(event) => handlePrintLabel(params.row.boxInCarton)}
            >
              {" "}
              {intl.formatMessage({ id: "CheckIn.PrintLabel" })}
            </Button>
          );
        },
      },
    ]);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <PageHeader
            title={
              intl.formatMessage({ id: "CheckIn.Title" }) +
              " [" +
              dossierKey +
              "]"
            }
          />
        </Grid>
        <Grid item xs={12} textAlign="left">
          <Box
            pt={1}
            pb={1}
            pl={0.5}
            sx={{
              background: "#bcb7b7",
              color: "white",
              borderTop: "2px solid white",
            }}
          >
            <Grid item md={3} xs={12} mb={1}>
              <TextField
                id="boxInInput"
                variant="outlined"
                sx={{ backgroundColor: "white", borderRadius: "0" }}
                placeholder={intl.formatMessage({
                  id: "CheckIn.BoxInBarcode",
                })}
                size="small"
                value={boxInBarcode}
                onChange={(e) => {
                  handleBoxInBarcodeChange(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <BarcodeIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                id="boxCheckInInput"
                variant="outlined"
                sx={{ backgroundColor: "white", borderRadius: "0" }}
                placeholder={intl.formatMessage({
                  id: "CheckIn.CheckInBarcode",
                })}
                size="small"
                value={checkInBarcode}
                onChange={(e) => {
                  handleCheckInBarcodeChange(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <BarcodeIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="right">
          <Box
            sx={{
              background: "#9C9B9B",
              color: "white",
              borderTop: "2px solid white",
            }}
          >
            <Button
              sx={{ color: "white", fontSize: "16px" }}
              onClick={(event) => handleSaveCheckIn()}
            >
              {" "}
              {intl.formatMessage({ id: "CheckIn.Ok" })}
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <CustomTable
            columns={columns}
            rows={checkInData}
            id={"boxInCarton"}
            rowHeight={50}
            headerHeight={50}
            tableHeight={420}
            enableSelection={true}
            setSelectedRows={onSelectionFunc}
            selectedRows={selectedBoxInBarcodes}
          />
          <Button onClick={(event) => handlePrintLabel("")}>
            {" "}
            {intl.formatMessage({ id: "CheckIn.PrintAll" })}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
